import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { AiNodeData } from '../../../node-edit.type';
import { WorkflowModel } from '@models/workflow.model';
import { MatOption, MatSelect } from '@angular/material/select';

@Component({
  selector: 'edit-ai',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    MatSelect,
    MatOption,
  ],
  templateUrl: './edit-ai.component.html',
  styleUrl: './edit-ai.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditAIComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAIComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<AiNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public readonly modelKeys = Object.keys(WorkflowModel.AiModelsMap);
  public readonly modelsMap = WorkflowModel.AiModelsMap;

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.AI.NAME'), [Validators.required]],
    promt: [null, [Validators.required]],
    model: [WorkflowModel.AiModels.VIA_1, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        promt: this.selectedNodeForEdit().data.promt,
        model: this.selectedNodeForEdit().data.model,
      })
    }
  }
}
